

























































































































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import type { Lesson } from '@/models/lesson';

import { lessonWebservice } from '@/webservices/lesson';
import { pmLessonWebservice } from '@/webservices/pmlesson';
import { xLessonWebservice } from '@/webservices/xlesson';

import StoreUpdateLessonModal from '@/components/knowledge/lessons/StoreUpdateLessonModal.vue';
import StoreUpdatePMLessonModal from '@/components/knowledge/pm/lessons/StoreUpdatePMLessonModal.vue';
import StoreUpdateXLessonModal from '@/components/knowledge/x/lessons/StoreUpdateXLessonModal.vue';

import type { Trade } from '@/models/trade';
import type { Phase } from '@/models/phase';
import type { Topic } from '@/models/topic';
import type { PMLesson } from '@/models/pmlesson';
import type { PMPhase } from '@/models/pmphase';
import type { PMSubPhase } from '@/models/pmsubphase';
import type { Company } from '@/models/company';
import type { XLesson } from '@/models/xlesson';
import type { XProcess } from '@/models/xprocess';
import type { XSubProcess } from '@/models/xsubprocess';
import ConfirmModal from '@/components/prine/ConfirmModal.vue';
import { LessonType } from '@/enums/LessonType';
import { LessonLike } from '@/helpers/types/LessonLike';
import { hasAnyPermission, hasPermission } from '@/helpers/auth/permissionHelpers';
import { PERMISSIONS } from '@/helpers/auth/permissions';

@Component({
    name: 'ApprovalList',
    methods: { hasAnyPermission, hasPermission },
    computed: {
        PERMISSIONS() {
            return PERMISSIONS;
        },
        LessonType() {
            return LessonType;
        },
    },
    components: {
        ConfirmModal,
        StoreUpdateLessonModal,
        StoreUpdatePMLessonModal,
        StoreUpdateXLessonModal,
    },
})
export default class ApprovalList extends Vue {
    @Getter('account/company') public company: Company;
    @Getter('utils/currentLocale') public currentLocale: string;
    private selectedLesson: Lesson = {} as Lesson;
    private selectedTrade: Trade = {} as Trade;
    private selectedPhase: Phase = {} as Phase;
    private selectedTopic: Topic = {} as Topic;

    private selectedPMPhase: PMPhase = {} as PMPhase;
    private selectedPMSubPhase: PMSubPhase = {} as PMSubPhase;
    private selectedPMLesson: PMLesson = {} as PMLesson;

    private selectedXProcess: XProcess = {} as XProcess;
    private selectedXSubProcess: XSubProcess = {} as XSubProcess;
    private selectedXLesson: XLesson = {} as XLesson;

    private isStoreUpdateLessonModalActive: boolean = false;
    private isStoreUpdatePMLessonModalActive: boolean = false;
    private isStoreUpdateXLessonModalActive: boolean = false;

    private isConfirmModalActive: boolean = false;
    private deleteCallback: () => void;

    @Getter('approval/openLessons') private openLessons;
    @Getter('approval/openPMLessons') private openPMLessons;
    @Getter('approval/openXLessons') private openXLessons;

    @Action('approval/fetchAllOpen') private loadAllOpenLessons;

    private tableSettings = {
        isStriped: true,
        isHoverable: true,
        isPaginated: false,
    };

    private mounted() {
        this.loadAllOpenLessons();
    }

    private tryRemoveLesson(lesson: LessonLike, type: LessonType) {
        switch (type) {
            case LessonType.Lesson:
                this.deleteCallback = () => this.deleteLesson(lesson as Lesson);
                break;
            case LessonType.PMLesson:
                this.deleteCallback = () => this.deletePMLesson(lesson as PMLesson);
                break;
            case LessonType.XLesson:
                this.deleteCallback = () => this.deleteXLesson(lesson as XLesson);
                break;
        }
        this.isConfirmModalActive = true;
    }

    private confirmModalHandler(answer: boolean) {
        if (answer && this.deleteCallback) {
            this.deleteCallback();
        }
        this.isConfirmModalActive = false;
    }

    private approveChanged(lesson: Lesson, approved: boolean) {
        lessonWebservice
            .storeApproved(lesson, approved)
            .then(() => {
                this.loadAllOpenLessons();
            })
            .catch((error) => {
                console.log(error);
            });
    }

    private approvePMChanged(pmLesson: PMLesson, approved: boolean) {
        pmLessonWebservice
            .storeApproved(pmLesson, approved)
            .then(() => {
                this.loadAllOpenLessons();
            })
            .catch((error) => {
                console.log(error);
            });
    }

    private approveXChanged(xLesson: XLesson, approved: boolean) {
        xLessonWebservice
            .storeApproved(xLesson, approved)
            .then(() => {
                this.loadAllOpenLessons();
            })
            .catch((error) => {
                console.log(error);
            });
    }

    private toggleStoreUpdateLessonModal(lesson: Lesson, topics: Topic[] = []) {
        this.selectedLesson = lesson;

        // Earlier a lesson was connected to multiple topics, therefor show multiple but use the first
        if (topics.length > 0) {
            this.selectedTopic = topics[0];
        }

        // Set also the selected trade
        if (lesson && lesson.trades.length > 0) {
            this.selectedTrade = lesson.trades[0];
        }

        this.isStoreUpdateLessonModalActive = !this.isStoreUpdateLessonModalActive;

        this.loadAllOpenLessons();
    }

    private toggleStoreUpdatePMLessonModal(pmLesson: PMLesson) {
        this.selectedPMLesson = pmLesson;

        if (pmLesson.sub_phase && pmLesson.sub_phase.phase) {
            this.selectedPMPhase = pmLesson.sub_phase.phase;
            this.selectedPMSubPhase = pmLesson.sub_phase;
        }

        this.isStoreUpdatePMLessonModalActive = !this.isStoreUpdatePMLessonModalActive;

        this.loadAllOpenLessons();
    }

    private toggleStoreUpdateXLessonModal(xLesson: XLesson) {
        this.selectedXLesson = xLesson;

        if (xLesson.x_sub_process && xLesson.x_sub_process.x_process) {
            this.selectedXProcess = xLesson.x_sub_process.x_process;
            this.selectedXSubProcess = xLesson.x_sub_process;
        }

        this.isStoreUpdateXLessonModalActive = !this.isStoreUpdateXLessonModalActive;

        this.loadAllOpenLessons();
    }

    private deleteLesson(lesson: Lesson) {
        const self = this;

        lessonWebservice
            .remove(lesson)
            .then(() => {
                self.loadAllOpenLessons();

                self.$buefy.toast.open({
                    duration: 7000,
                    message: this.$t('toastMessages.delete.lesson').toString(),
                    type: 'is-success',
                });
            })
            .catch((error) => {
                console.error(error);
            });
    }

    private deletePMLesson(pmLesson: PMLesson) {
        const self = this;

        pmLessonWebservice
            .remove(pmLesson)
            .then(() => {
                self.loadAllOpenLessons();

                self.$buefy.toast.open({
                    duration: 7000,
                    message: this.$t('toastMessages.delete.lesson').toString(),
                    type: 'is-success',
                });
            })
            .catch((error) => {
                console.error(error);
            });
    }

    private deleteXLesson(xLesson: XLesson) {
        xLessonWebservice
            .remove(xLesson)
            .then(() => {
                this.loadAllOpenLessons();
                this.$buefy.toast.open({
                    duration: 7000,
                    message: this.$t('toastMessages.delete.lesson').toString(),
                    type: 'is-success',
                });
            })
            .catch((error) => {
                console.error(error);
            });
    }
}
